import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';
import { FavouritesApiRoutes } from './favourites-api.routes';
import { IBooking } from 'src/app/models';
import { objectToSnake } from 'ts-case-convert';

@Injectable({
  providedIn: 'root',
})
export class FavouritesHttpService extends BaseHttpService {
  private baseURL = `favorites`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  getFavourites(userId: number, page: number, size: number) {
    const path = `${FavouritesApiRoutes.GET_USERS_FAVOURITES}/${userId}?page=${page}&size=${size}`;
    const url = this.routerService.mount(`${this.baseURL}${path}`);
    return this.read(url);
  };

  getFavourite(favouriteId: number) {
    const path = `/${favouriteId}`;
    const url = this.routerService.mount(`${this.baseURL}${path}`);
    return this.read(url);
  };
  
  deleteFavourite(favouriteId: number) {
    const path = `/${favouriteId}`;
    const url = this.routerService.mount(`${this.baseURL}${path}`);
    return this.delete(url);
  };

  createFavourite = (request: any) => {
    const body = objectToSnake(request);
    const url = this.routerService.mount(`${this.baseURL}`);
    return this.create(body, url);
  };

  editFavourite = (favouriteId: number, request: any) => {
    const body = objectToSnake(request);
    const url = this.routerService.mount(`${this.baseURL}`);
    return this.update(body, url);
  }

  createFavouriteFromBooking = (favouriteName: string, bookingId: number) => {
    const path = `/${bookingId}`;
    const url = this.routerService.mount(`${this.baseURL}/booking${path}`);
    return this.create(favouriteName, url);
  };

}
